module.exports = __webpack_public_path__ + "public-ui/img/banner.8e105319.png";